import { v4 as uuid } from 'uuid';

export const getInitialInfieldLocation = (locationExternalId: string) => {
  return {
    externalId: uuid(),
    rootLocationExternalId: locationExternalId,
  };
};
